import * as React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const Retry = () => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="refresh-ccw-01" clip-path="url(#clip0_1436_93931)">
                    <path
                        id="Icon (Stroke)"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.38095 1.53333C6.69683 1.53333 5.17345 2.21961 4.06947 3.33125C3.49216 3.91257 2.83658 4.70065 2.30917 5.36667H5.33333C5.75412 5.36667 6.09524 5.70992 6.09524 6.13333C6.09524 6.55675 5.75412 6.9 5.33333 6.9H0.761905C0.341116 6.9 0 6.55675 0 6.13333V1.53333C0 1.10992 0.341116 0.766667 0.761905 0.766667C1.18269 0.766667 1.52381 1.10992 1.52381 1.53333V3.90574C1.98239 3.34457 2.50426 2.73812 2.99161 2.24739C4.3697 0.859736 6.27627 0 8.38095 0C12.5888 0 16 3.43248 16 7.66667C16 11.9009 12.5888 15.3333 8.38095 15.3333C4.90632 15.3333 1.97677 12.9935 1.05979 9.79589C0.943122 9.38907 1.17629 8.96411 1.58058 8.84672C1.98488 8.72933 2.4072 8.96395 2.52386 9.37077C3.25768 11.9297 5.60325 13.8 8.38095 13.8C11.7473 13.8 14.4762 11.054 14.4762 7.66667C14.4762 4.27932 11.7473 1.53333 8.38095 1.53333Z"
                        fill="#4E4C55"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1436_93931">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="refresh-ccw-01" clip-path="url(#clip0_1436_93931)">
                    <path
                        id="Icon (Stroke)"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.38095 1.53333C6.69683 1.53333 5.17345 2.21961 4.06947 3.33125C3.49216 3.91257 2.83658 4.70065 2.30917 5.36667H5.33333C5.75412 5.36667 6.09524 5.70992 6.09524 6.13333C6.09524 6.55675 5.75412 6.9 5.33333 6.9H0.761905C0.341116 6.9 0 6.55675 0 6.13333V1.53333C0 1.10992 0.341116 0.766667 0.761905 0.766667C1.18269 0.766667 1.52381 1.10992 1.52381 1.53333V3.90574C1.98239 3.34457 2.50426 2.73812 2.99161 2.24739C4.3697 0.859736 6.27627 0 8.38095 0C12.5888 0 16 3.43248 16 7.66667C16 11.9009 12.5888 15.3333 8.38095 15.3333C4.90632 15.3333 1.97677 12.9935 1.05979 9.79589C0.943122 9.38907 1.17629 8.96411 1.58058 8.84672C1.98488 8.72933 2.4072 8.96395 2.52386 9.37077C3.25768 11.9297 5.60325 13.8 8.38095 13.8C11.7473 13.8 14.4762 11.054 14.4762 7.66667C14.4762 4.27932 11.7473 1.53333 8.38095 1.53333Z"
                        fill="#4E4C55"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1436_93931">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="refresh-ccw-01" clip-path="url(#clip0_1436_93931)">
                <path
                    id="Icon (Stroke)"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.38095 1.53333C6.69683 1.53333 5.17345 2.21961 4.06947 3.33125C3.49216 3.91257 2.83658 4.70065 2.30917 5.36667H5.33333C5.75412 5.36667 6.09524 5.70992 6.09524 6.13333C6.09524 6.55675 5.75412 6.9 5.33333 6.9H0.761905C0.341116 6.9 0 6.55675 0 6.13333V1.53333C0 1.10992 0.341116 0.766667 0.761905 0.766667C1.18269 0.766667 1.52381 1.10992 1.52381 1.53333V3.90574C1.98239 3.34457 2.50426 2.73812 2.99161 2.24739C4.3697 0.859736 6.27627 0 8.38095 0C12.5888 0 16 3.43248 16 7.66667C16 11.9009 12.5888 15.3333 8.38095 15.3333C4.90632 15.3333 1.97677 12.9935 1.05979 9.79589C0.943122 9.38907 1.17629 8.96411 1.58058 8.84672C1.98488 8.72933 2.4072 8.96395 2.52386 9.37077C3.25768 11.9297 5.60325 13.8 8.38095 13.8C11.7473 13.8 14.4762 11.054 14.4762 7.66667C14.4762 4.27932 11.7473 1.53333 8.38095 1.53333Z"
                    fill="#4E4C55"
                />
            </g>
            <defs>
                <clipPath id="clip0_1436_93931">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Retry;
